import {Item} from '../../models/Item';
import {AbstractMainPlugin} from '../AbstractMainPlugin';


export class OpeningHoursPlugin extends AbstractMainPlugin {

  constructor(item: Item) {
    super(item);

    this.initListeners();
  }

  private assignInput() {
    this.item.config.assignInput('opening_hours_1', {label: 'Mon', value: '00:00, 23:59', type: 'text'});
    this.item.config.assignInput('opening_hours_2', {label: 'Tue', value: '00:00, 23:59', type: 'text'});
    this.item.config.assignInput('opening_hours_3', {label: 'Wed', value: '00:00, 23:59', type: 'text'});
    this.item.config.assignInput('opening_hours_4', {label: 'Thu', value: '00:00, 23:59', type: 'text'});
    this.item.config.assignInput('opening_hours_5', {label: 'Fri', value: '00:00, 23:59', type: 'text'});
    this.item.config.assignInput('opening_hours_6', {label: 'Sat', value: '00:00, 23:59', type: 'text'});
    this.item.config.assignInput('opening_hours_7', {label: 'Sun', value: '00:00, 23:59', type: 'text'});
  }

  private initListeners() {
    const input = this.item.config.getInputByName('opening_hours_1');
    if (!input) {
      if (this.item.config.getTool().has_opening_hours) {
        this.assignInput();
      }
    }
  }

}
